<template>
  <!--  応募管理审核-->
  <div class="main-css">
    <!--  标题-->
    <div class="title-css">{{ $t("applicationReview") }}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box"></div>
      <!--    表格部分-->
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 95%"
          height="520px"
          @selection-change="handleSelectionChange"
          @sort-change="changeTableSort"
          v-loading="loading"
        >
          <!--------------选择框----------------->
          <el-table-column type="selection" width="45"></el-table-column>
          <!--------------氏名----------------->
          <el-table-column
            prop="name"
            label="应聘号"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template
              slot="header"
              slot-scope="scope"
              :show-overflow-tooltip="true"
            >
              <p>{{ $t("namejop") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-- ----------------------案件名---------------------- -->
          <el-table-column prop="jobName" label="案件名" width="190">
            <template slot="header">
              <p>{{ $t("caseName") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!--------------教育機関番号----------------->
          <el-table-column
            prop="educationId"
            label="教育機関番号"
            min-width="95"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("educationId") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-- ----------------------教育機関---------------------- -->
          <el-table-column
            prop="educationName"
            min-width="120"
            label="教育機関"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("educationalInstitution") }}</p>
              <el-input
                v-model="searchData4"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-- ----------------------医療機関番号---------------------- -->
          <el-table-column
            prop="medicalId"
            label="医療機関番号"
            min-width="95"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("medicId") }}</p>
              <el-input
                v-model="searchData5"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-- ----------------------医療機関---------------------- -->
          <el-table-column
            prop="medicalName"
            label="医療機関"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("medicalInstitution") }}</p>
              <el-input
                v-model="searchData6"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-------------------------------応募日付------------------------------------------->
          <el-table-column prop="createTime" label="応募日付" width="190">
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("fundingDayPayment") }}</p>
            </template>
            <template slot-scope="scope">
              <span>
                {{ scope.row.createTime.substring(0, 10) }}
              </span>
            </template>
          </el-table-column>
          <!--------------操作----------------->
          <el-table-column label="操作" fixed="right" width="300">
            <template slot="header">
              <p class="operate">{{ $t("operate") }}</p>
            </template>
            <template slot-scope="scope">
              <button
                class="save-button"
                @click="handlePromiseClick(scope.row)"
              >
                {{ $t("promise") }}
              </button>
              <button
                class="save-button"
                @click="handleRejectedClick(scope.row)"
              >
                {{ $t("rejection") }}
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--    分页部分-->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalNum"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  fuzzyQueryUserInfoAdmin,
  progressReviewQueryAllApplyJob,
  queryAllApplyJob,
  fuzzyQueryAllApplyJob,
  updateAdminReview,
  jobCaseApplyQuery
} from "../../js/api";
import AES from "../../js/AES";

export default {
  name: "adminTalentManagement",
  components: {},
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "",
      searchData8: "",
      searchData9: "",
      searchData10: "",
      searchData11: "",
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      totalNum: 0
    };
  },

  created() {
    this.getList();
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        this.getList();
      }
    },
    //模糊查询
    inputSearch() {
      const fakeInfo = {
        applyId: "",
        createTime: "",
        educationId: this.searchData3,
        educationName: this.searchData4,
        jobId: "",
        jobName: this.searchData2,
        medicalId: this.searchData5,
        medicalName: this.searchData6,
        name: this.searchData1,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        principal: "",
        resumeId: "",
        username: ""
      };
      fuzzyQueryAllApplyJob(fakeInfo)
        .then(res => {
          console.log("-----模糊查询接口-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
            this.totalNum = aesFecInfo.total;
          }
        })
        .catch(res => {
          console.log("-----模糊查询接口-----");
          console.log(res);
        });
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "minimum") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["minimum"] - b["minimum"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["minimum"] - a["minimum"]
          );
        }
      } else if (column.prop === "maximumAmount") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["maximumAmount"] - b["maximumAmount"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["maximumAmount"] - a["maximumAmount"]
          );
        }
      } else if (column.prop === "pageView") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["pageView"] - b["pageView"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["pageView"] - a["pageView"]
          );
        }
      }
    },
    handleCurrentChange(evt) {
      this.currentPage = evt;
      this.getList();
    },
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.currentPage = 1;
      this.inputSearch();
    },
    handleSelectionChange(val) {
      // this.currentPage = val;
      this.inputSearch();
    },
    //承诺按钮
    handlePromiseClick(row) {
      if (row.applyStatus === "1" || row.applyStatus === "2") {
        this.$message.error("已被审核。");
      } else {
        console.log(row);
        var fakeInfo = {
          applyId: row.applyId,
          jobId: row.jobId,
          resumeId: row.resumeId,
          status: 1
        };
        console.log(fakeInfo);
        updateAdminReview(fakeInfo)
          .then(res => {
            console.log("--------状态修改接口--------");
            // console.log(res);
            if (res.data.code === "A0000") {
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              console.log(aesFecInfo);
              // let msg = AES.decrypt(res.data.data);
              this.$message({
                message: this.$t("successfulOperation"),
                type: "success"
              });
              this.getList();
            } else {
              this.$message.error("操作失败。");
            }
          })
          .catch(res => {});
      }
    },
    //拒绝按钮
    handleRejectedClick(row) {
      if (row.applyStatus === "1" || row.applyStatus === "2") {
        this.$message.error(this.$t("reviewed"));
      } else {
        console.log(row);
        var fakeInfo = {
          applyId: row.applyId,
          jobId: row.jobId,
          resumeId: row.resumeId,
          status: 2
        };
        console.log(fakeInfo);
        updateAdminReview(fakeInfo)
          .then(res => {
            console.log("--------管理员待应聘审核信息拒绝接口--------");
            console.log(res);
            if (res.data.code === "A0000") {
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              console.log(aesFecInfo);
              // this.$message({
              //   message: AES.decrypt(res.data.data),
              //   type: "success"
              // });
              this.$message.success(this.$t("successfullyDeleted"));
              this.getList();
            } else {
              this.$message.error("操作失败。");
            }
          })
          .catch(res => {});
      }
    },
    handleClick(evt) {
      if (evt === "0") {
        //长期
        console.log("长大");
      } else {
        //短期
        console.log("短大");
      }
    },
    //基础信息浏览
    getList() {
      var fakeInfo = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      console.log(fakeInfo);
      progressReviewQueryAllApplyJob(fakeInfo)
        .then(res => {
          console.log("--------管理员查询待应聘审核信息接口--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.totalNum = aesFecInfo.total;
            this.tableData = aesFecInfo.data;
            // this.$message({
            //   message: AES.decrypt(res.data.data),
            //   type: 'success'
            // });
          } else {
            this.$message.error("登录失败。");
          }
        })
        .catch(res => {});
    }
  }
};
</script>

<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}

.main-box {
  /*表格*/
  margin-top: 0px;
  width: 100%;
  height: 0;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}

.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #686868; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 76px; /*行间距*/
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}

.button-css {
  width: 90px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
  text-align: center;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.operate {
  height: 51px;
}

.table {
  position: absolute;
  width: 92%;
  margin-top: 10px;
  height: 580px;
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans", serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.table /deep/ .el-dropdown {
  /*下拉框*/
  width: 60px;
}

.table-img-css {
  border-radius: 50%;
}

.el-dropdown-link {
  /*下拉框*/
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}

.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -4px;
  right: -48px;
  width: 67px;
}

.save-button {
  width: 69px;
  height: 36px;
  background: #fff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}

.pagination {
  /*分页*/
  width: 95%;
  height: 50px;
  margin-top: 590px;
}

.pagination-main {
  /*分页*/
  float: right;
  margin-right: 10px;
  display: flex;
}

.rowsPage {
  /*RowsPage*/
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/pages/administratorApplicationReviea/index.vue